<template>
  <v-dialog
     v-bind="$attrs"
     v-model="showDialog"
   >
     <template v-slot:default="dialog">
       <v-card>
          <v-card-title>
          <span class="text-h5">{{title}}</span>
          <v-spacer></v-spacer>
          <v-btn dark fab color="primary" depressed text v-if="close" small @click="dialog.value = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
         <v-card-text class="py-0 px-0 ">
           <slot
             name="content"
           />
         </v-card-text>
         <v-card-actions v-if="$slots.actions" class="justify-end">
           <slot
             slot="actions"
             name="actions"
           />
         </v-card-actions>
       </v-card>
     </template>
   </v-dialog>
</template>
<script>
  export default {
    name: 'MaterialDailog',
    props: {
      title: {
        type: String,
        default: ''
      },
      dialog: {
        type: Boolean,
        default: false
      },
      close: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        showDialog: this.dialog
      }
    },
    watch: {
      showDialog (val) {
        this.$emit('on-dialog-change', val)
      },
      dialog (val) {
        this.showDialog = val
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dialog-toolbat-title
</style>
